import React from 'react'
import {useAppSelector} from "../../core/hooks";
import CommentsPanel from "./comments-panel";
import HistoryPanel from "./history-panel";
import {Pending, Offer, WaitingEr, OnWay, Closed, Hospitalization, BookingOffer} from './request-components'

const Content = () => {
  const {activePanel, request, er_call} = useAppSelector(state => state.requests)
  let Content: any
  if(activePanel === 'data') {
    if(er_call) {
      switch (er_call.status) {
        case 1:
          Content = <WaitingEr/>
          break
        case 2:
        case 3:
        case 4:
          Content = <OnWay/>
          break
        case 5:
        case 6:
          Content = <Closed/>
          break;
        case 7:
          Content = <Hospitalization/>
          break;
        case 8:
          Content = <Hospitalization/>
          break;
        case 9:
        case 10:
        case 11:
        case 12:
        case 22:
          Content = <Closed/>
          break;
        case 13:
        case 14:
        case 19:
        case 20:
        case 21:
          Content = <OnWay/>
          break;
        case 15:
        case 17:
        case 18:
          Content = <Pending/>
          break;
        case 16:
          Content = <BookingOffer/>
          break;
        default:
          Content = ''
      }
    } else {
      switch (request?.status) {
        case 1:
        case 4:
          Content = <Pending/>
          break
        case 2:
          Content = <Offer/>
          break
        case 3:
          Content = <Offer/>
          break
        case 5:
          Content = <Pending/>
          break
        default:
          Content = ''
      }
    }
  } else if (activePanel === 'comment') {
    // @ts-ignore
    Content = <CommentsPanel isSentry={false}/>
  } else {
    Content = <HistoryPanel/>
  }

  return (Content)
}

export default Content
